// extracted by mini-css-extract-plugin
module.exports = {"modal":"HistoryModal_modal__d0pR7","container":"HistoryModal_container__3KkrY"};